import { useRef } from 'react';
import { useHeroDrift } from '@/hooks/useHeroDrift';

/**
 * 히어로 배경 메시. 블롭 4개가 각자 keyframes 궤적을 돈다.
 * 나열 순서가 페인트 순서라 배리언트마다 다르다 — 시안 그대로 유지한다.
 */
const BLOB_ORDER = {
  main: ['a', 'c', 'd', 'b'],
  plan: ['b', 'd', 'a', 'c'],
};

export function HeroMesh({ variant = 'main' }) {
  const ref = useRef(null);
  useHeroDrift(ref);

  const className = variant === 'plan' ? 'hero-mesh hero-mesh-plan' : 'hero-mesh';

  return (
    <div ref={ref} aria-hidden="true" data-drift className={className}>
      <div className="hero-mesh-layer">
        {BLOB_ORDER[variant].map((key) => (
          <span key={key} className={`hero-mesh-blob hero-mesh-blob-${key}`} />
        ))}
      </div>
    </div>
  );
}
